module.exports = __webpack_public_path__ + "img/c4.14e9fe83.png";